export const environment = {
  production: true,
  mapsKey: "AIzaSyASTXa8ZyGjkbH2YwhXSJ3QcbW6MUNVvHk",
  apiUrl: "/Api",
  gtmKey: "GTM-NGLK422",
  hotjarId: "2375581",
  serviceLinkApiUrl: "https://dev.cspaz.vwgroup.se/api/qa/sl",
  features: ["service-link", "tech-update"],
  appInsights: {
    connectionString:
      "InstrumentationKey=b1bb60ce-f51e-43cb-8be6-0baf927ac108;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=6d229394-0b25-4e0d-8fbd-f6ea2367371d"
  }
};
